module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix choice"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasImage),
      expression: "hasImage"
    }],
    staticClass: "btn-add-pic"
  }, [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": 'upload-img-poll-' + (_vm.index + 1)
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'upload-img-poll-' + (_vm.index + 1)
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle dash-color-skin-light-30 cursor-pointer"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "setup-margin-input",
    class: {
      'setup-no-img': !_vm.hasImage, 'setup-width-input': _vm.hasImage
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.choiceObj.text),
      expression: "choiceObj.text"
    }],
    staticClass: "dash-border-color-skin input-poll-choice",
    class: {
      'input-error': _vm.errors.has('choice')
    },
    attrs: {
      "type": "text",
      "name": "choice",
      "placeholder": _vm.labels[_vm.nowLang].choicePlaceHolder
    },
    domProps: {
      "value": (_vm.choiceObj.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.choiceObj, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "trash-poll dash-color-skin-light-30"
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.delChoice(_vm.index)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('choice')),
      expression: "errors.has('choice')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('choice')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c776d69!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/choicePoll.vue
// module id = 3549
// module chunks = 1